import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServerContextService } from '../../../../feature-vault/src/lib/servers/server-context.service';
import { RetentionPolicy } from '../../../../domain/src/lib/retention/retention.model';
import {
  resolveTenantId,
  tenantHeaders,
  withTenantParam,
} from '../shared/tenant-context.util';

@Injectable({ providedIn: 'root' })
export class RetentionPolicyService {
  private readonly http = inject(HttpClient);
  private readonly serverContext = inject(ServerContextService);
  private readonly retentionPath = '/api/document-retention';

  private retentionUrl(): string {
    return this.retentionPath;
  }

  listPolicies(isActive?: boolean): Observable<RetentionPolicy[]> {
    let params = new HttpParams();
    if (typeof isActive === 'boolean') {
      params = params.set('is_active', String(isActive));
    }
    const tenantId = resolveTenantId(this.serverContext);
    return this.http.get<RetentionPolicy[]>(`${this.retentionUrl()}/policies`, {
      headers: tenantHeaders(tenantId),
      params: withTenantParam(tenantId, params),
    });
  }

  getPolicy(id: string): Observable<RetentionPolicy> {
    const tenantId = resolveTenantId(this.serverContext);
    return this.http.get<RetentionPolicy>(`${this.retentionUrl()}/policies/${id}`, {
      headers: tenantHeaders(tenantId),
      params: withTenantParam(tenantId),
    });
  }

  createPolicy(data: Partial<RetentionPolicy>): Observable<RetentionPolicy> {
    const tenantId = resolveTenantId(this.serverContext);
    return this.http.post<RetentionPolicy>(`${this.retentionUrl()}/policies`, data, {
      headers: tenantHeaders(tenantId),
      params: withTenantParam(tenantId),
    });
  }

  updatePolicy(id: string, data: Partial<RetentionPolicy>): Observable<RetentionPolicy> {
    const tenantId = resolveTenantId(this.serverContext);
    return this.http.put<RetentionPolicy>(`${this.retentionUrl()}/policies/${id}`, data, {
      headers: tenantHeaders(tenantId),
      params: withTenantParam(tenantId),
    });
  }

  deletePolicy(id: string): Observable<unknown> {
    const tenantId = resolveTenantId(this.serverContext);
    return this.http.delete(`${this.retentionUrl()}/policies/${id}`, {
      headers: tenantHeaders(tenantId),
      params: withTenantParam(tenantId),
    });
  }
}
